import service from "@/utils/axios";

/**
 * 获取资源列表
 * @method GET /system/menu/list
 * @param   
 * access public
 * */
export const getMenuList = (params) => service.get('/system/menu/list', { params });

/**
 * 获取资源列表
 * @method GET /system/menu/{id}
 * @param   
 * access public
 * */
export const getMenu = (id) => service.get(`/system/menu/${id}`);

/**
 * 更新资源
 * @method PUT  /system/menu
 * @param
 * */
export const updateMenu = (params) => service.put('/system/menu', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);

/**
* 删除资源
* @method DELETE  /system/menu/{id}
* @param
* */
export const delMenu = (id) => service.delete(`/system/menu/${id}`);

/**
* 新增资源
* @method POST  /system/menu
* @param
* */
export const addMenu = (params) => service.post('/system/menu', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 获取资源列表
 * @method GET /system/menu/tree
 * @param   
 */
export const getPermsByUserId = () => service.get(`/system/menu/getPermsByUserId`);

/**
 * 获取资源信息包括路由
 * @method GET /system/agent/getInfo
 * @param   
 */
export const getAgentInfo = () => service.get(`/system/agent/getInfo`);
